import { useAppScale } from "@/contexts/AppScaleContext";
import React, { useEffect, useRef, useState } from "react";

// Exact Figma canvas dimensions
// autoHeight: canvas cao đúng 1 màn hình (100vh) thay vì DESIGN_H cố định. Canvas
// là flex column: trang con tự quyết phần nào giãn (flex-1) và phần nào tự cuộn
// khi nội dung vượt quá (min-h-0).
export default function UseResponsive({ children, height, width = 0, isHiddenBg = false, background, transformOrigin = "top left", autoHeight = false }) {
  const DESIGN_W = width || 880;
  const wrapRef = useRef(null);
  const [scale, setScale] = useState(1);
  // Desktop: LayoutApp thu nhỏ cả app bằng transform:scale -> 1 màn hình thật
  // tương ứng 100dvh / appScale px layout (mobile appScale = 1).
  const { scale: appScale } = useAppScale();

    useEffect(() => {
      const el = wrapRef.current;
      if (!el) return;
      const ro = new ResizeObserver(([entry]) => {
        setScale(entry.contentRect.width / DESIGN_W);
      });
      ro.observe(el);
      return () => ro.disconnect();
    }, []);

  // Chiều cao 1 màn hình = CSS 100dvh: trình duyệt tự cập nhật theo vùng nhìn thấy
  // thật khi thanh địa chỉ mobile ẩn/hiện. KHÔNG đọc window.innerHeight (chụp 1 lần
  // lúc mount -> vào từ Home đã cuộn thì sai), cũng không dùng 100svh (thanh địa
  // chỉ đang ẩn thì trang ngắn hơn màn hình, kéo lên là trình duyệt "cuộn" để hiện
  // Quy ra px layout (bù scale của app trên desktop), rồi ra px design (bù scale canvas).
  const viewportLayoutH = `calc(100dvh / ${appScale || 1})`;
  const DESIGN_H = autoHeight
    ? `calc(100dvh / ${appScale || 1} / ${scale})`
    : height || 1904;

  return (
    <div
      className={autoHeight ? "min-h-svh" : "min-h-screen"}
      style={{
        background: `${isHiddenBg ? "none" : background || 'linear-gradient(180deg, #FDECC5 0%, #FEC790 93.44%)'}`,
      }}
    >
      <div
        ref={wrapRef}
        className="w-full max-w-[880x] mx-auto relative"
        style={{ height: autoHeight ? viewportLayoutH : `${DESIGN_H * scale}px` }}
      >
        <div
          style={{
            width: DESIGN_W,
            height: DESIGN_H,
            ...(autoHeight && { display: "flex", flexDirection: "column" }),
            transformOrigin: transformOrigin,
            transform: `scale(${scale})`,
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
